import './InspectionType.style.less'
import { useEffect, useState } from 'react'
import HeaderComponent from '../../../Components/HeaderComponent/HeaderComponent'
import ToolbarComponent from '../../../Components/ToolbarComponent/ToolbarComponent'
import ModalAddNewInspectionType from './ModalNewInspectionType/ModalAddNewInspectionType'
import { DataType } from '@/screens/Order/Pages/EditOrder/components/ProductRequirementForm/measurement.column'
import PopUpMenu from '@/screens/SystemConfigure/Components/PopUpMenu/PopUpMenu'
import { Space } from 'antd'
import Table, { ColumnsType } from 'antd/lib/table'
import useMasterData from '@/hook/MasterData'
import { useMutation, useQuery } from 'react-query'
import {
  deletePropertyValue,
  getInspectionType,
} from '../../DataManagement.transform'
import { isEmptyValue } from '@/utils/common'
import { debounce } from 'lodash'

function InspectionType() {
  const [modalAddNew, setModalAddNew] = useState(false)
  const [selectedItem, setselectedItem] = useState(null)
  const [selectedProperty, setselectedProperty] = useState(null)
  const [page, setpage] = useState(1)
  const [search, setsearch] = useState('')
  const { data } = useMasterData()

  useEffect(() => {
    const tmpSelectedProperty = data?.find(
      (item) => item.name == 'inspectionType'
    )
    setselectedProperty(tmpSelectedProperty)
  }, [data])

  const transformData = (data) => {
    return data?.map((item: any) => {
      const tmp = !isEmptyValue(item.value) ? JSON.parse(item.value) : null
      return {
        ...item,
        name: tmp?.name,
        acronym: tmp?.acronym,
      }
    })
  }

  const deleteMutation = useMutation(async (id: string) => {
    await deletePropertyValue(id)
  })

  const onDeleteValue = async (id: string) => {
    await deleteMutation.mutateAsync(id)
    await refetch()
  }

  const {
    data: value,
    isLoading,
    refetch,
  } = useQuery(
    ['inspectionType', page, search],
    async () => {
      const tmp = {
        reference_id: selectedProperty?.id,
        name: 'inspectionType',
        page_size: 10,
        page_number: page,
        search: search,
      }
      return await getInspectionType(tmp)
    },
    {
      enabled: !!selectedProperty,
    }
  )

  const onEdit = (item) => {
    setselectedItem(item)
    setModalAddNew(true)
  }

  const onAdd = () => {
    setselectedItem(null)
    setModalAddNew(true)
  }

  const onSearch = debounce(async (value) => {
    setsearch(value)
  }, 500)

  const columns: ColumnsType<DataType> = [
    {
      title: 'id',
      dataIndex: 'id',
      key: 'id',
      // sorter: (a: any, b: any) => a - b,
      className: 'hide-column',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
      // sorter: (a: any, b: any) => a - b,
    },
    {
      title: 'Acronym',
      dataIndex: 'acronym',
      key: 'acronym',
      // sorter: (a: any, b: any) => a - b,
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record: any) => (
        <Space size="middle">
          <PopUpMenu
            onDelete={() => onDeleteValue(record.id)}
            onEdit={() => onEdit(record)}
          />
        </Space>
      ),
    },
  ]

  return (
    <div>
      <HeaderComponent title="Inspection Types" />
      <ToolbarComponent
        buttonText="New Inspection Type"
        onAdd={onAdd}
        onSearch={onSearch}
      />
      <Table
        columns={columns}
        dataSource={transformData(value?.data)}
        loading={isLoading}
        pagination={{
          current: page,
          total: value?.pagination?.total_record,
          pageSize: 10,
          onChange: (page) => setpage(page),
        }}
      />
      {modalAddNew && (
        <ModalAddNewInspectionType
          visible={modalAddNew}
          onClose={() => setModalAddNew(!modalAddNew)}
          propertyId={selectedProperty?.id}
          data={selectedItem}
        />
      )}
    </div>
  )
}

export default InspectionType
